/**
 * @fileoverview main.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
/**
 * Developed by: Kalindu Tharanga
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import './i18n'; // Initialize i18next

console.log("Welcome to Kith Travels, Discover Sri Lanka, Where Every Journey Tells a Story");

const logErrorToBackend = async (errorMsg, stack, url) => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://engine.kithtravels.com/api';
    await fetch(`${apiUrl}/health/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: errorMsg, stack: stack, url: url, source: 'frontend' })
    });
  } catch (err) {
    // Silently fail if logging fails
  }
};

const handleGlobalError = (msg, stack, url) => {
  console.error("KITH travels is facing a technical issue, and the team is working on it.");
  alert("KITH travels is facing a technical issue, and the team is working on it.");
  logErrorToBackend(msg, stack, url);
};

window.addEventListener('error', (event) => {
  handleGlobalError(event.message, event.error?.stack, window.location.href);
});

window.addEventListener('unhandledrejection', (event) => {
  handleGlobalError(event.reason?.message || 'Unhandled Promise Rejection', event.reason?.stack, window.location.href);
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
